import React from 'react';
import '../styles/components.css';

const Card = ({ 
  children, 
  icon: Icon, 
  title, 
  text, 
  image,
  imageAlt = '',
  className = '',
  ...props 
}) => {
  return (
    <div className={`card-modern ${className}`} {...props}>
      {image && (
        <div className="card-image-wrapper" style={{ marginBottom: 'var(--spacing-md)' }}>
          <img 
            src={image} 
            alt={imageAlt || title || ''} 
            className="card-image"
            style={{
              width: '100%',
              height: '180px',
              objectFit: 'cover',
              borderRadius: 'var(--border-radius-lg)'
            }}
          />
        </div>
      )}
      {Icon && (
        <div className="card-icon">
          <Icon size={48} />
        </div>
      )}
      {title && <h3 className="card-title">{title}</h3>}
      {text && <p className="card-text">{text}</p>}
      {children}
    </div>
  );
};

export default Card;
